module.exports = "<div class=\"content_container\">\n  <div class=\"header_content\">Live SMART Scoreboards</div>\n  <div class=\"content_list\">\n    <div class=\"content_list_item\" *ngFor=\"let user of users\">\n      <a [routerLink]=\"['/scoreboard', user.id]\">{{user.name}}</a>\n    </div>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/users.component.html
// module id = 414
// module chunks = 2